<div
    [@slideContentRight]="animationState"
    (@slideContentRight.start)="onAnimationStart($event)"
    (@slideContentRight.done)="onAnimationDone($event)"
    class="root"
>
    <ng-template [cdkPortalOutlet]="componentPortal"></ng-template>
</div>
